import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import CatalogInputs from './inputs';
import CatalogProducts from './products';

class Component extends BaseComponent {
    shouldComponentUpdate(nextProps) {
        if (nextProps.user != this.props.user) {
            return true;
        }

        return false;
    }

    render({ mode }) {
        return (
            <catalog-content id='catalog-content' mode={mode}>
                <h1 className={mode && mode == 'journal' ? 'has-margin-25' : ''}>Shop</h1>
                {this.renderSubheader()}
                {this.renderInputs()}
                <CatalogProducts mode={mode} />
            </catalog-content>
        );
    }

    renderSubheader = () => {
        if (!this.props.mode || this.props.mode != 'journal') {
            return (
                <row className='is-justified-center'>
                    <column className='is-9 is-12-mobile has-text-center'>
                        <p className='has-text-cente has-margin-5-bottom-mobile'>
                            Browse our unique collection of Tarot Readings,
                            Astrology Reports and I Ching readings to get
                            personalized insight for any unique situation in your life.
                        </p>
                    </column>
                </row>
            );
        }

        return null;
    }

    renderInputs = () => {
        if (!this.props.mode || this.props.mode != 'journal') {
            return (
                <CatalogInputs />
            );
        }

        return null;
    }
}

const mapStateToProps = (state) => ({
    user: state.user,
});

export default connect(mapStateToProps)(Component);
